import React from "react";
import { filter, label, group, btn } from './ItemsFilter.module.css';
import Button from '../../components/UI/Button'
import { BRAZIL, KENYA, COLUMBIA, ALL } from "../../utils/constants";
import classNames from 'classnames/bind';
import { func } from 'prop-types';

const itemsFilterStyles = classNames.bind({ btn })

const ItemsFilter = ({ onFilterSelect }) => (
  <div className={filter}>
    <div className={label}>
      Or filter
    </div>

    <div className={group}>
      {[BRAZIL, KENYA, COLUMBIA, ALL].map(filterName => {
        return (
          <Button
            key={filterName}
            styles={itemsFilterStyles}
            onClick={() => onFilterSelect(filterName)}
          >
            {filterName}
          </Button>
        )
      })}
    </div>
  </div>
)

ItemsFilter.propTypes = {
  onFilterSelect: func,
}

ItemsFilter.defaultProps = {
  onFilterSelect: () => { },
}
export default ItemsFilter